import React from 'react';
import { images } from '../../utils/imagePaths';
import "../../styles/clientlogo.css"

const ClientLogo = () => {
  const logos = [
    { id: 1, src: images.clientLogo },
    { id: 2, src: images.clientLogo },
    { id: 3, src: images.clientLogo },
    { id: 4, src: images.clientLogo },
    { id: 5, src: images.clientLogo },
  ];

  return (
    <section className="client">
      <div className="container">
        <div className="wrapper">
          <ul className="client-list">
            {logos.map((logo) => (
              <li key={logo.id}>
                <img src={logo.src} alt={`Client logo ${logo.id}`} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default ClientLogo;